// contentZoneBlockTypes.js — shared content-zone block type helpers (layout editor)

const CONTENT_ZONE_BLOCK_TYPE = 'CONTENT_ZONE';

const normalizeString = (value) => String(value || '').trim();

export function isContentZoneBlockType(block) {
  return normalizeString(block?.type).toUpperCase() === CONTENT_ZONE_BLOCK_TYPE;
}

export { CONTENT_ZONE_BLOCK_TYPE };
